<div class="border-bottom-1 text-muted border-start-0 border-end-0 border-dashed border">
    <table class="table align-middle table-nowrap pb-0 mb-0">
        <thead class="text-muted" style="cursor:default">
            <tr>
                <th>
                    Product
                </th>
                <th>
                    Product Info
                </th>
                <th style="justify-content: center;">
                    Price
                </th>
            </tr>
        </thead>
    </table>
</div>
<div *ngIf="isLoadingVal"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
<div style="max-height: 350px; overflow: auto; display: grid;">
    <div class="p-2">
        <table class="table align-middle table-nowrap pb-0 mb-0">
            <tbody class="list form-check-all" style="cursor:default">
                <tr *ngFor="let data of listItems" id="i_{{data.id}}" style="background-color: var(--vz-footer-bg);">
                    <td style="width: 0">
                        <div class="d-flex align-items-center gap-2">
                            <div class="flex-shrink-0">
                                <img src='{{data.img}}' class=" avatar-xs rounded-circle p-0 m-0">
                            </div>
                            <div>
                                <div *ngIf="data.number">
                                    {{data.number}}
                                </div>
                                <p class="mb-0 fs-12 text-muted">
                                    <span *ngIf="data.matterNumber" i18n="@@Modal_Requisition_Body_MatNum">
                                        Mat#</span>
                                    <span *ngIf="data.matterNumber else elseNoMatter">
                                        {{data.matterNumber}}
                                    </span>
                                    <ng-template #elseNoMatter>
                                        <strong style="color: #ed5e5e;">No Matter</strong>
                                    </ng-template>
                                </p>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex align-items-center">

                            <div>
                                <div *ngIf="data.client else elseNoClient">
                                    {{data.client.fullName}}
                                </div>

                                <ng-template #elseNoClient>
                                    <strong style="color: #ed5e5e;">No Client</strong>
                                </ng-template>


                                <p class="mb-0 fs-12 text-muted">
                                    <span *ngIf="data.account else elseNoAccountName">
                                        {{data.account.fullName}}
                                    </span>

                                    <ng-template #elseNoAccountName>
                                        <strong style="color: #ed5e5e;">No Contact</strong>
                                    </ng-template>
                                </p>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="data.total" style="font-size: 1rem">
                            {{data.total |currency}}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="border-bottom-0 border-start-0 border-end-0 border-dashed border d-grid" style="padding-top: 1rem">
    <div class="d-flex justify-content-between align-items-center pb-3">
        <p class="m-0">Sub-Total</p>

        <p class="m-0"><span class="total_price">{{subtotalCost| currency}}</span></p>

    </div>
    <div class="d-flex justify-content-between align-items-center pb-3">
        <span>Estimated Tax (13%):</span>

        <span>{{taxCost| currency}}</span>

    </div>
    <div class="border-bottom-0 border-start-0 border-end-0 border-dashed border d-grid  pb-3"></div>
    <div class="d-flex justify-content-between align-items-center">
        <h5 class="m-0 ">Total</h5>

        <h5 class="m-0"><span class="total_price">{{totalCost| currency}}</span></h5>

    </div>
</div>